import { Card, CardContent } from "@/components/ui/card";

export interface DashboardCardData {
    title: string;
    value: number;
    description: string;
    isDestructive?: boolean;
}

interface DashboardCardProps extends DashboardCardData {}

const DashboardCard: React.FC<DashboardCardProps> = ({ 
    title, 
    value, 
    description, 
    isDestructive = false 
}) => {
    return (
        <Card className="bg-[#FCFCFC] relative border rounded-2xl">
            <CardContent className="flex flex-col items-start justify-start w-[280px] py-4">
                <p className="font-normal text-base text-gray-500">{title}</p>
                <div className="h-[60px]" />
                <p className={`text-2xl font-bold ${isDestructive ? 'text-red-600' : ''}`}>
                    {value}
                </p>
                <p className="font-normal text-sm text-gray-500">{description}</p>
            </CardContent>
        </Card>
    );
};

export default DashboardCard